import { Fail } from './fail';

export class ServerFail extends Fail {
  _message = 'Unknown error on server';
}
